import {GET_SLIDER_DATA} from "../action_types";

export const getSliderData = () => ({type: GET_SLIDER_DATA, api: true});
